import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  TextInput,
} from '@met/react-components';
import React, { useEffect, useRef, useState } from 'react';

const AddVersionModal = ({ hidden, toggle, onSaveClick }) => {
  const [version, setVersion] = useState('');
  const versionRef = useRef(null);

  useEffect(() => {
    if (!hidden) versionRef.current.focus();
  }, [hidden, versionRef]);

  const handleSaveClick = () => {
    onSaveClick(version)
      .then(() => setVersion(''))
      .then(() => toggle());
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      handleSaveClick();
    }
  };

  return (
    <Modal centered hidden={hidden} toggle={toggle}>
      <ModalContent>
        <ModalHeader toggle={toggle}>
          <FontAwesomeIcon icon='code-branch' /> Add Version
        </ModalHeader>
        <ModalBody>
          <p>
            A new version creates an entirely separate internationalization file
            that can be published to. It is useful for wanting to separate test
            environments from production environments.
          </p>
          <TextInput
            inputRef={versionRef}
            placeholder='Version Name'
            value={version}
            onKeyPress={handleKeyPress}
            onChange={e => setVersion(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={toggle}>Close</Button>
          <Button primary onClick={handleSaveClick}>
            Save Changes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddVersionModal;
